import styled, { css, keyframes } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 100%;
  padding: 2rem;
  border: 1px solid var(--primary);
  border-radius: 16px;
`;

const appearFronRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-450px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;
  width: 100%;
  animation: ${appearFronRight} 1s;

  span {
    font-size: 1.375rem;
    font-weight: 800;
    margin-bottom: 1.87rem;
    margin-top: 0.07rem;
    color: var(--primary);
  }

  p {
    font-size: 1.13rem;
    font-weight: 800;
    margin-bottom: 1.88rem;
  }
  
  p > span {
    cursor: pointer;
  }

  // p + p {
  //   font-size: 1.38rem;
  //   font-weight: 800;
  //   color: var(--primary);
  // }

`;


export const ContainerSectionFooter = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

  margin-top: 15px;
  margin-bottom: 15px;
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: stretch;

  div + div {
    margin-left: 1rem;
  }
`;

interface ButtonProps {
  bgColor?: string;
  fgColor?: string;
  disabled?: boolean;
}

export const Button = styled.div<ButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0.5rem 1rem;
  width: 100%;
  max-width: 300px;
  border-radius: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  ${props => props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `
  }

  span {
    font-size: 1.375rem;
    ${props => props.fgColor &&
    css`
          color: ${props.fgColor};
      `}
    font-weight: 800;
  }

  ${props => props.disabled === true &&
    css`
      opacity: 0.5;
      cursor: no-drop;
    `
  }

`;

export const ContainerPix = styled.section`
  width: 100%;
`
